<template lang="html">
  <section class="about-company-section">
    <div class="placed-backg box-image"></div>

    <div class="container oversized-container">
      <div class="row">
        <div class="col-lg-5 col-xl-6 col-image"></div>

        <div class="col-lg-6 col-text">
          <h1 class="mb-2 title-s1 c-primary">Quienes somos</h1>

          <!-- <h5 class="subtitle"></h5> -->
          <p class="mb-3">
            En Hules Automotrices Becerra nos especializamos principalmente
            en las líneas de soporte de motor y transmisión, bandas
            automotrices e industriales, mangueras de radiador y calefacción,
            topes de hule, sistema de enfriamiento automotriz, tomas de agua,
            depósitos de anticongelante, bombas de agua, Poleas de
            accesorios y distribución, tubos de enfriamiento, tapas de punterías,
            múltiples de admisión, Tensores de accesorios, enfriadores de
            aceite, cabezas de motor, motores, bases de amortiguador, bujes de
            horquilla, hules en general, hule para piso, entre otras líneas.
          </p>

          <p>
            Somos una empresa jalisciense que cuenta con el conocimiento y
            experiencia de 20 años, buscando siempre ofrecer un servicio de
            calidad a nuestros clientes. Comercializando y distribuyendo
            productos en el mercado del repuesto de autopartes automotrices
            así como asesorando a nuestros consumidores en las principales
            marcas reconocidas del ramo automotriz e industrial.
          </p>

          <!-- <div class="b-logos">
            <img src="public/images/pages/about-us/logos.png">
          </div> -->

          <!-- <h6 class="mt-4 subtitle"></h6> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>
